import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import LightSpinnerWrapper from './../../../reusable/Wrappers/LightSpinnerWrapper/LightSpinnerWrapper.jsx';
import Modal from './../../../reusable/Modal/Modal.index.jsx';
import LightTable from '../../../reusable/LightTable/LightTable';
import ReactPaginate from 'react-paginate';
import { toLower, unescape, trimEnd } from 'lodash';
import { experianCountries, usStates, experianPageSize } from "../../../constants";

const headerItems = [
    { key: "index", label: null },
    { key: "companyName", label: <FormattedMessage id="Entities_Edit_UIText_editThirdParty.companyName" /> },
    { key: "address", label: <FormattedMessage id="Entities_Edit_UIText_editThirdParty.streetAddress" /> },
    { key: "city", label: <FormattedMessage id="Entities_Edit_UIText_editThirdParty.city" /> },
    { key: "state", label: <FormattedMessage id="Entities_Edit_UIText_editThirdParty.stateProvince" /> },
    { key: "country", label: <FormattedMessage id="Entities_Edit_UIText_editThirdParty.country" /> },
    { key: "experianBin", label: <FormattedMessage id="Entities_Edit_UIText_editThirdParty.experianBin" /> }
]

class ExperianLookupModal extends React.Component {

    static propTypes = {
        experianResponse: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        experianError: PropTypes.string,
        closeModal: PropTypes.func.isRequired,
        experianCall: PropTypes.func.isRequired,
        entityName: PropTypes.string.isRequired,
        chooseExperian: PropTypes.func
    };

    static defaultProps = {
        entityName: "",
        experianResponse: null
    };

    constructor(props) {
        super(props);
        this.state = {
            entityName: this.props.entityName,
            country: "United States",
            city: "",
            address: "",
            state: "",
            selectedExperian: null,
            currentPage: 0
        };

        this.changeExperianEntity = this.changeExperianEntity.bind(this);
        this.lookupExperian = this.lookupExperian.bind(this);
        this.submitExperian = this.submitExperian.bind(this);
        this.selectExperian = this.selectExperian.bind(this);
        this.changeCity = this.changeCity.bind(this);
        this.changeAddress = this.changeAddress.bind(this);
        this.changeCountry = this.changeCountry.bind(this);
        this.changeState = this.changeState.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.noEntries = this.noEntries.bind(this);
    }

    selectExperian(item) {
        this.setState({ selectedExperian: item });
    }

    lookupExperian(page = 0, resetPageCounter = true) {
        if (resetPageCounter) {
            this.setState({ currentPage: 0 })
        }
        if (this.state.entityName) {
            this.setState({ selectedExperian: null })
            this.props.experianCall(this.state.entityName, {
                country: this.state.country !== "all" ? this.state.country : null,
                state: this.state.state,
                city: this.state.city,
                address: this.state.address
            }, page);
        }
    }

    changeExperianEntity(event) {
        this.setState({
            entityName: event.target.value
        })
    }

    submitExperian() {
        this.props.chooseExperian(this.state.selectedExperian);
    }

    itemCount() {
        if (this.props.experianResponse && this.props.experianResponse.count) {
            return <div>
                {this.props.experianResponse.count}&nbsp;
                <FormattedMessage id="Entities_Edit_UIText_editThirdParty.itemCount" />
                </div>
        } else {
            return null;
        }
    }

    noEntries() {
        return (<div>
            <div className="no-entries">
                <FormattedMessage id="Entities_Edit_UIText_editThirdParty.noResults"/>
            </div>
            <div className="experian_no-entries">
                <FormattedMessage id={this.props.experianError ? this.props.experianError : "Entities_Edit_UIText_editThirdParty.experianNoResults"} />
            </div>
        </div>)

    }

    handleChangePage(page) {
        this.setState({ currentPage: page.selected })
        this.lookupExperian(page.selected, false)
    }

    changeCountry(e) {
        this.setState({
            country: e.target.value
        })
    }

    changeCity(e) {
        this.setState({
            city: e.target.value
        })
    }

    changeAddress(e) {
        this.setState({
            address: e.target.value
        })
    }

    changeState(e) {
        this.setState({
            state: e.target.value
        })
    }

    render() {
        let experianList = [];
        let pageCount = 0;
        if (this.props.experianResponse && this.props.experianResponse.experianCompanyTOs ) {
            this.props.experianResponse.experianCompanyTOs.forEach((item, index) => {
                experianList.push({
                    key: item.id,
                    onClick: () => {
                        this.selectExperian(item.id)
                    },
                    index: (
                        <div>
                            <input
                                type="radio"
                                name="experianId"
                                onChange={(e) => this.selectExperian(item.id)}
                                checked={this.state.selectedExperian === item.id} />
                            {++index + (this.state.currentPage * experianPageSize)}
                        </div>
                    ),
                    companyName: unescape(toLower(item.name)).replace(/&#38;/g, '&'),
                    address: toLower(item.street),
                    city: toLower(trimEnd(item.city, ", ")),
                    state: item.state,
                    country: toLower(item.country),
                    experianBin: `#${item.id}#`
                });
            })
            pageCount = (
                (this.props.experianResponse.count - (this.props.experianResponse.count % experianPageSize)) / experianPageSize)
                + (this.props.experianResponse.count % experianPageSize > 0 ? 1 : 0)
        }

        const countryList = experianCountries.map(country => <option value={country.value} key={country.value}>{country.name}</option>)
        const stateList = usStates.map(state => <option value={state.abbreviation} key={state.abbreviation}>{state.name}</option>)

        let buttons = []
        if (this.props.experianResponse && this.state.selectedExperian) {
            buttons.push({
                text: <FormattedMessage id="General_CoreFunctionality_UIText_general.ok"/>,
                click: this.submitExperian,
                primary:    true
            });
        }

        buttons.push({
            text: <FormattedMessage id="General_CoreFunctionality_UIText_general.cancel"/>,
            click: this.props.closeModal,
            primary:    false
        });

        return (
            <div id="experian-lookup" className="notranslate">
                <Modal
                    buttons={buttons}
                    isOpen={true}
                    closeButtonHandler={this.props.closeModal}
                    arrowPosition="left">
                    <h2 className="modal-header">
                        <FormattedMessage id="Entities_Edit_UIText_editThirdParty.entityLookupTitle" />
                    </h2>
                    <div className="experian-lookup-body">
                        <div className="form">
                            <div className="row">
                                <div className="form-group">
                                    <label htmlFor="experian_lookup_entity" >
                                        <span className="required-field-star"><FormattedMessage
                                            id="Entities_Review_Error_errorCompanies.CompanyName"/></span>
                                        <span> (<FormattedMessage
                                            id="General_CoreFunctionality_UIText_general.required"/>)</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="experian_lookup_entity"
                                        placeholder=""
                                        value={this.state.entityName}
                                        onChange={this.changeExperianEntity}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="experian-country" >
                                        <span className="required-field-star"><FormattedMessage
                                            id="Entities_Edit_UIText_editThirdParty.country"/></span>
                                        <span> (<FormattedMessage
                                            id="General_CoreFunctionality_UIText_general.required"/>)</span>
                                    </label>
                                    <select
                                        id="experian-country"
                                        onChange={this.changeCountry}
                                        value={this.state.country}
                                        disabled={true}
                                    >
                                        {countryList}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="experian-state" type="text">
                                        <FormattedMessage id="Entities_Edit_UIText_editThirdParty.stateProvince" />
                                    </label>
                                    <select
                                        id="experian-state"
                                        value={this.state.state}
                                        onChange={this.changeState}
                                    >
                                        <option value="">
                                            {this.props.intl.formatMessage({id: 'Entities_Edit_UIText_editThirdParty.allStates'})}
                                        </option>
                                        { stateList }
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="experian-city" type="text">
                                        <FormattedMessage id="Entities_Edit_UIText_editThirdParty.city" />
                                    </label>
                                    <input
                                        type="text"
                                        id="experian-city"
                                        value={this.state.city}
                                        onChange={this.changeCity}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="experian-street_address">
                                        <FormattedMessage id="Entities_Edit_UIText_editThirdParty.streetAddress" />
                                    </label>
                                    <input
                                        type="text"
                                        id="experian-street_address"
                                        value={this.state.address}
                                        onChange={this.changeAddress}
                                    />
                                </div>
                            </div>

                            <div className="lookup-buttons">
                                <button type="button"
                                        className="button-primary-sm lookup-btn"
                                        onClick={(e) => this.lookupExperian(0)}
                                        disabled={this.props.experianResponse === null || !this.state.entityName.length}>
                                    <span><FormattedMessage id="Entities_Edit_UIText_editThirdParty.lookUp" /></span>
                                </button>
                            </div>

                        </div>

                        <div className="divider"></div>
                        <LightSpinnerWrapper isLoading={this.props.experianResponse === null}>
                            <div className="experian-list">
                                <div className="experian-items-count">{ this.itemCount() }</div>
                                <LightTable headerItems={headerItems} listItems={experianList} noEntries={this.noEntries} />
                            </div>
                        </LightSpinnerWrapper>
                    </div>

                    { experianList && !!experianList.length && (
                        <ReactPaginate pageCount={pageCount}
                                       marginPagesDisplayed={1}
                                       pageRangeDisplayed={4}
                                       containerClassName={"pagination"}
                                       initialPage={this.state.currentPage}
                                       disableInitialCallback={true}
                                       onPageChange={this.handleChangePage}
                                       nextLabel={<span className='la-TriangleRight' />}
                                       previousLabel={<span className='la-TriangleLeft' />}
                        />
                    )}

                </Modal>
            </div>
        );

    }

}

export default injectIntl(ExperianLookupModal);


// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/components/ExperianLookupModal.jsx